'use client'

import type { AppRouter } from '@algoacademy/backend/appRouter'
import { createTRPCContext } from '@trpc/tanstack-react-query'

export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>()
